import type { FC } from 'react'

import Checkbox from '@/components/Checkbox'

export interface Filter {
  notFlagged: boolean
  potentialFraud: boolean
}

export const DEFAULT_FILTER: Filter = {
  notFlagged: true,
  potentialFraud: true,
}

interface Props {
  filter: Filter
  onChangeFilter: (sectionFilters: Filter) => void
}

const FraudFilter: FC<Props> = ({ filter, onChangeFilter }) => (
  <>
    <Checkbox
      label="Not flagged"
      checked={filter.notFlagged}
      onChange={e =>
        onChangeFilter({
          ...filter,
          notFlagged: e.target.checked,
        })
      }
    />
    <Checkbox
      label="Suspicions of fraud"
      checked={filter.potentialFraud}
      onChange={e =>
        onChangeFilter({
          ...filter,
          potentialFraud: e.target.checked,
        })
      }
    />
  </>
)

export default FraudFilter
